import { RemoveEventListenerFunction } from "@/types";
import { onUnmounted } from "vue";

// Wrapper to use listeners in components, automatically removes the listener on unmount
export function useRemoveListener(cb: () => RemoveEventListenerFunction): void {
  const removeListener = cb();
  onUnmounted(() => removeListener());
}
